export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100/60 text-accent-700 text-xs font-medium mb-4">
              追剧锦囊
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              追剧指南
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              不知道怎么选剧？这份追剧指南帮你快速找到心仪好剧
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            <div className="lg:col-span-3">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                <div className="group bg-background-100 rounded-2xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
                  <div className="h-44 md:h-48 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20setup%20with%20large%20TV%20screen%20showing%20a%20Chinese%20drama%2C%20warm%20ambient%20lighting%2C%20comfortable%20couch%2C%20popcorn%2C%20evening%20atmosphere%2C%20relaxing%20mood%2C%20photorealistic%20interior&width=600&height=400&seq=card-guide-01&orientation=landscape"
                      alt="新手追剧入门指南"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <span className="text-xs font-medium text-primary-400">新手必读</span>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950 mt-1 mb-2 group-hover:text-primary-400 transition-colors">新手追剧入门指南</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">从选剧到追剧全流程攻略，帮你快速找到适合的剧集类型和观影节奏</p>
                  </div>
                </div>

                <div className="group bg-background-100 rounded-2xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
                  <div className="h-44 md:h-48 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Collection%20of%20award%20winning%20film%20and%20drama%20posters%20displayed%20on%20a%20gallery%20wall%2C%20elegant%20curation%2C%20cinematic%20aesthetic%2C%20warm%20museum%20lighting%2C%20sophisticated%20art%20display&width=600&height=400&seq=card-guide-02&orientation=landscape"
                      alt="豆瓣9分以上神剧合集"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <span className="text-xs font-medium text-accent-400">高分推荐</span>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950 mt-1 mb-2 group-hover:text-primary-400 transition-colors">豆瓣9分以上神剧合集</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">精选口碑评分9分以上的高分剧集，每部都是不容错过的经典佳作</p>
                  </div>
                </div>

                <div className="group bg-background-100 rounded-2xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
                  <div className="h-44 md:h-48 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20person%20watching%20drama%20on%20smartphone%20during%20commute%20on%20subway%2C%20urban%20lifestyle%2C%20warm%20lighting%2C%20mobile%20entertainment%2C%20casual%20daily%20life%20scene%2C%20natural%20photography&width=600&height=400&seq=card-guide-03&orientation=landscape"
                      alt="通勤追剧时间表"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <span className="text-xs font-medium text-secondary-400">追剧技巧</span>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950 mt-1 mb-2 group-hover:text-primary-400 transition-colors">通勤追剧时间表</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">根据每集时长和通勤时间，智能安排你的每日追剧计划，碎片时间高效看剧</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="group bg-background-100 rounded-2xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer sm:col-span-2 lg:col-span-2">
              <div className="flex flex-col sm:flex-row h-full">
                <div className="sm:w-2/5 h-40 sm:h-auto overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Multiple%20genres%20of%20TV%20dramas%20represented%20as%20artistic%20concept%20collage%2C%20historical%20costume%2C%20romance%2C%20thriller%2C%20fantasy%20elements%20blended%2C%20cinematic%20color%20grading%2C%20creative%20composition&width=600&height=400&seq=card-guide-04&orientation=landscape"
                    alt="按类型选剧攻略"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                  <span className="text-xs font-medium text-primary-400">深度指南</span>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 mt-1 mb-2 group-hover:text-primary-400 transition-colors">按类型选剧攻略</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">古装、悬疑、爱情、都市……根据你的心情和喜好选择最适合的剧集类型，告别选择困难症</p>
                </div>
              </div>
            </div>

            <div className="group bg-background-100 rounded-2xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
              <div className="h-40 md:h-44 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20calendar%20concept%20with%20drama%20release%20dates%20visualized%20artistically%2C%20film%20strip%20aesthetic%2C%20warm%20lighting%2C%20creative%20typography%20feel%2C%20modern%20editorial%20design%2C%20sophisticated%20layout&width=600&height=400&seq=card-guide-05&orientation=landscape"
                  alt="每周新剧上线日历"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs font-medium text-accent-400">新剧速递</span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mt-1 mb-2 group-hover:text-primary-400 transition-colors">每周新剧上线日历</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">每周更新即将上线的剧集排期，提前锁定你最想看的新剧，不错过首播</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}